import { createContext, useContext, useEffect, useRef, useState } from "react";

/**
 * v4.6.1 — the settings form publishes its save state here so the single
 * persistent admin topbar can render Save / Discard only when dirty.
 */
const SettingsActionsContext = createContext(null);

export function SettingsActionsProvider({ children }) {
  const [actions, setActions] = useState(null);
  return (
    <SettingsActionsContext.Provider value={{ actions, setActions }}>
      {children}
    </SettingsActionsContext.Provider>
  );
}

export function useSettingsActionsBar() {
  return useContext(SettingsActionsContext)?.actions || null;
}

// Called by a settings form to expose its state to the topbar.
export function usePublishSettingsActions({ dirty, saving, saved, onSave, onDiscard }) {
  const ctx = useContext(SettingsActionsContext);
  const saveRef = useRef(onSave);
  const discardRef = useRef(onDiscard);
  saveRef.current = onSave;
  discardRef.current = onDiscard;

  const setActions = ctx?.setActions;
  useEffect(() => {
    if (!setActions) return;
    setActions({
      dirty,
      saving,
      saved,
      save: () => saveRef.current?.(),
      discard: () => discardRef.current?.(),
    });
  }, [setActions, dirty, saving, saved]);

  useEffect(() => () => setActions?.(null), [setActions]);
}
